<template>
   <v-dialog
   v-model="openDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title class="title-card">
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="form"
            v-model="valid"
          >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.nome"
                required
                :rules="nameRules"
                label="Nome"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.cpnj"
                v-mask ="'##.###.###/####-##'"
                :rules="nameRules"
                label="CNPJ"
                required
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.descricao"
                required
                :rules="nameRules"
                label="Descrição"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
         </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="closeModal"
        >
          Cancelar
        </v-btn>
        <v-btn
          dark
          :loading="loading"
          color="primary"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  props:{
        openDialog: Boolean
    },
    data () {
      return {
        valid:false,
        formTitle:'Novo cadastro',
        nameRules: [
          v => !!v || 'Campo requerido',
        ],
        dialog: false,
        loading:false,
        obj: {
            descricao: '',
            nome:'',
            cpnj:'',
            active: true,
        },
      }
    },
    methods: {
      ...mapActions('empresa', ['saveEmpresa']),
      async save() {
        this.$refs.form.validate()
        /* eslint-disable no-console */
        if (this.valid) {
          try {
              await this.saveEmpresa(this.obj)
          } catch (error) {
              console.error(error);
          } finally {
              this.closeModal();
          }
        }
      },
      closeModal () {
        this.$emit('closeModal')
      },
      reset(){
        this.$refs.form.reset()
      },
    watch:{
      openDialog(){
          this.reset();
      }
    }
  }
}
</script>
<style>
.v-main {
  width: 95% !important;
}
.menu {
  width: 100% !important;
  padding-top: 0px !important;
  z-index: 1;
  margin-top: 0px !important;
  position: inherit !important;
}
.btn-new{
  padding-top: 10px;
  justify-content: flex-end;
  display: flex;
}
.title-card{
  background: #0030b1 !important;
  color: white;
  padding: 20px !important;
}
.v-card__text {
  padding-top: 20px !important;
}
</style>